import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../utils/api';
import { isDevAuthEnabled, devSignIn } from '../utils/devAuth';
import { fetchSession } from '../services/auth';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [checking, setChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      let token = localStorage.getItem('token');

      // Demo/dev mode: auto-provision a dev token so visitors
      // never see the login page (zero-auth demo for Render).
      if (isDevAuthEnabled() && !token) {
        devSignIn({ email: 'demo@digitalninja.app', name: 'Demo User' });
        token = localStorage.getItem('token');
      }

      // Dev auth: trust local token
      if (isDevAuthEnabled() && token) {
        if (mounted) {
          setIsAuthenticated(true);
          setChecking(false);
        }
        return;
      }

      // Try to fetch session from backend (cookie-based auth after Google OAuth)
      if (!token) {
        const user = await fetchSession(null);
        if (user) {
          token = localStorage.getItem('token');
        }
      }

      if (!token) {
        if (mounted) {
          setIsAuthenticated(false);
          setChecking(false);
        }
        return;
      }

      try {
        await api.get('/auth/me');
        if (mounted) {
          setIsAuthenticated(true);
          setChecking(false);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        if (mounted) {
          setIsAuthenticated(false);
          setChecking(false);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      }
    };

    checkAuth();

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      mounted = false;
    };
  }, [location.pathname]);

  if (checking) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#1c1c1e]">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#ff4500]"></div>
          <p className="text-white mt-4 text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;